import { render, staticRenderFns } from "./e-svg-text-wrap.vue?vue&type=template&id=2a66797c&scoped=true"
import script from "./e-svg-text-wrap.vue?vue&type=script&lang=js"
export * from "./e-svg-text-wrap.vue?vue&type=script&lang=js"
import style0 from "./e-svg-text-wrap.vue?vue&type=style&index=0&id=2a66797c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a66797c",
  null
  
)

export default component.exports